module.exports = __webpack_public_path__ + "img/help_icon.f056ce56.svg";